import { DrawerItem, ListGroup } from "@gisce/oficina-virtual-components"
import { useTranslation } from "react-i18next"
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  MapsHomeWork,
  Receipt,
  Equalizer,
  Apps
} from "@mui/icons-material";
import ContractationListItems from "../../CustomItems/ContractationListItems";
import useContractation from "@/components/Contractation/hooks/useContractation";
import useAuth from "@/components/Authentication/hooks/useAuth";
import { useMediaQuery, useTheme } from "@mui/material";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

export const GroupedSideBar = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const [searchParams, _setSearchParams] = useSearchParams();
  const params = useParams();
  const { pathname } = useLocation();
  const { isContractationPath } = useContractation();
  const { tokenVals } = useAuth();

  const isInContractPath = () => {
    return Object.values(t('common:url.contracts', {returnObjects: true, ...params}))
      .map(type => Object.values(type).includes(pathname))
      .some(val => val === true)
  }

  const breakpointDownMd = useMediaQuery(theme.breakpoints.down('md'));
  
  const firstContractPath = `common:url.contracts.${Settings.features.displayTypes.filter(type => type !== "multipoint")[0]}.default`;

  const ContractListGroup = <ListGroup
    icon={<MapsHomeWork />}
    titleLabel={t('common:text.home_contract_title')}
    startOpen={
      ( isInContractPath() || isContractationPath(pathname) )
      && ( searchParams.get("action") !== "consumption" )
    }
  >
    {<ContractationListItems />}
    <DrawerItem
      label={t('common:text.home_contract_list_title')}
      onClick={() => navigate(t(firstContractPath))}
      selected={isInContractPath() && searchParams.get("action") === null}
    />
    <DrawerItem
      label={t('common:text.home_contract_download_title')}
      onClick={() => navigate(t(firstContractPath) + `?action=download`)}
      selected={isInContractPath() && searchParams.get("action") === "download"}
    />
    <DrawerItem
      label={t('common:text.home_contract_power_change_title')}
      onClick={() => navigate(t(firstContractPath) + `?action=powChange`)}
      selected={isInContractPath() && searchParams.get("action") === "powChange"}
    />
    <DrawerItem
      label={t('common:text.home_contract_bank_change_title')}
      onClick={() => navigate(t(firstContractPath) + `?action=ibanChange`)}
      selected={isInContractPath() && searchParams.get("action") === "ibanChange"}
    />
    {Settings.features.notificacionAddressChange && (
      <DrawerItem
        toolTipProps={{
          title: tokenVals?.readonly ?
            t("common:text.token_readonly_tooltip")
          :
            "",
          placement: breakpointDownMd ? "bottom" : "right"
        }}
        label={t('common:text.home_contract_contact_change_title')}
        onClick={() => navigate(t(firstContractPath) + `?action=notifAddrChange`)}
        selected={isInContractPath() && searchParams.get("action") === "notifAddrChange"}
      />
    )}
    {Settings.features.noCesionSips && (
      <DrawerItem
        toolTipProps={{
          title: tokenVals?.readonly ?
            t("common:text.token_readonly_tooltip")
          :
            "",
          placement: breakpointDownMd ? "bottom" : "right"
        }}
        label={t('common:text.home_contract_sips_change_title')}
        onClick={() => navigate(t(firstContractPath) + `?action=noCesionSips`)}
        selected={isInContractPath() && searchParams.get("action") === "noCesionSips"}
      />
    )}
  </ListGroup>

  const InvoicesListGroup = <ListGroup 
    icon={<Receipt />}
    titleLabel={t('common:text.home_invoices_title')}
    startOpen={[
      t('common:url.invoices'),
      t('common:url.invoices_multipoint')
    ].includes(pathname)}
  >
    <DrawerItem
      label={t('common:text.home_invoices_list_title')}
      onClick={() => navigate(t('common:url.invoices'))}
      selected={
        pathname === t('common:url.invoices') && searchParams.get("action") === null
      }
    />
    <DrawerItem
      label={t('common:text.home_invoices_download_title')}
      onClick={() => navigate(
        t('common:url.invoices') + "?action=download"
      )}
      selected={pathname === t('common:url.invoices') && searchParams.get("action") === "download"}
    />
    {Settings?.invoices?.enablePayment && (
      <DrawerItem
        label={t('common:text.home_invoices_online_pay_title')}
        onClick={() => navigate(
          t('common:url.invoices') + "?action=payOnline"
        )}
        selected={pathname === t('common:url.invoices') && searchParams.get("action") === "payOnline"}
      />
    )}
  </ListGroup>

  const ConsumptionListGroup = <ListGroup
    icon={<Equalizer />}
    titleLabel={t('common:text.home_consumption_title')}
    startOpen={pathname === t('common:url.contracts') && searchParams.get("action") === "consumption"}
  >
	  <DrawerItem
      label={t('common:text.home_consumption_view_title')}
      onClick={() => navigate(t(firstContractPath) + `?action=consumption`)}
      selected={isInContractPath() && searchParams.get("action") === "consumption"}
    />
  </ListGroup>

  return <>
    <DrawerItem
      icon={<Apps />}
      label={t('common:text.home')}
      onClick={() => navigate('/')}
      selected={pathname === '/'}
    />

    {ContractListGroup}
    {InvoicesListGroup}
    {ConsumptionListGroup}

  </>
}
